export interface EstadoNodosResumenRow {
  nodoEstado?: string | null;
  vencido?: boolean | null;
  cantidad?: number;
  color?: string;
  porcentajeDelTotal?: number;
}

/** Fila agrupada por nodoEstado (sin cruce vencido). */
export function isEstadoNodosResumenPorEstado(row: EstadoNodosResumenRow): boolean {
  const nodoEstado = row?.nodoEstado;
  return nodoEstado != null && String(nodoEstado).trim() !== '' && row.vencido !== true;
}

/** Fila agregada solo por vencido (nodoEstado null/omitido). */
export function isEstadoNodosResumenVencidoAgregado(row: EstadoNodosResumenRow): boolean {
  const nodoEstado = row?.nodoEstado;
  const sinEstado = nodoEstado == null || String(nodoEstado).trim() === '';
  return sinEstado && row.vencido === true;
}

export function cantidadEstadoNodosVencidasAgregadas(rows: EstadoNodosResumenRow[]): number {
  const row = (rows ?? []).find(isEstadoNodosResumenVencidoAgregado);
  return Number(row?.cantidad) || 0;
}

export function findEstadoNodosResumenVencidoAgregado(
  rows: EstadoNodosResumenRow[],
): EstadoNodosResumenRow | undefined {
  return (rows ?? []).find(isEstadoNodosResumenVencidoAgregado);
}

/** Estados cuyo indicador suma vigentes + vencidas del mismo nodoEstado. */
const NODO_ESTADOS_SUMA_TODAS = new Set(['BLOQUEADO', 'EN_PROCESO']);

export function cantidadEstadoNodosPorEstado(
  rows: EstadoNodosResumenRow[],
  nodoEstado: string,
): number {
  const estadoUp = String(nodoEstado).toUpperCase();

  if (NODO_ESTADOS_SUMA_TODAS.has(estadoUp)) {
    return (rows ?? [])
      .filter(r => r.nodoEstado != null && String(r.nodoEstado).toUpperCase() === estadoUp)
      .reduce((sum, r) => sum + (Number(r.cantidad) || 0), 0);
  }

  const row = (rows ?? []).find(
    r => isEstadoNodosResumenPorEstado(r) && String(r.nodoEstado).toUpperCase() === estadoUp,
  );
  return Number(row?.cantidad) || 0;
}

export function findEstadoNodosResumenMetaPorEstado(
  rows: EstadoNodosResumenRow[],
  nodoEstado: string,
): EstadoNodosResumenRow | undefined {
  const estadoUp = String(nodoEstado).toUpperCase();

  return (rows ?? []).find(
    r =>
      r.nodoEstado != null
      && String(r.nodoEstado).toUpperCase() === estadoUp
      && (NODO_ESTADOS_SUMA_TODAS.has(estadoUp) ? r.vencido !== true : isEstadoNodosResumenPorEstado(r)),
  ) ?? (rows ?? []).find(
    r => r.nodoEstado != null && String(r.nodoEstado).toUpperCase() === estadoUp,
  );
}
